import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IMultiDiffSourceResolverService = ( createDecorator('multiDiffSourceResolverService'));
export { IMultiDiffSourceResolverService };
